import { Tabs } from 'antd';
import { UserRoles } from 'common/enums';
import React from 'react';
import { useSelector } from 'react-redux';
import CoursCollectifs from "../../../assets/images/app/about_icon.svg";
import Calendar from "../../../assets/images/app/calendar_teacher_icon.svg";
import GreenIdea from "../../../assets/images/app/greenIdea.svg";
import Students from "../../../assets/images/app/iam_student.svg";
import Publications from "../../../assets/images/app/publications_icon.svg";
import ClassIcon from "../../../assets/images/icons/teacher_classes.svg";
import { TabType } from '../types';
import './NavigationTabs.css';

const { TabPane } = Tabs;

interface NavigationTabsProps {
  activeTab: TabType;
  onChange: (tab: TabType) => void;
  children: React.ReactNode;
  data?: any;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  activeTab,
  onChange,
  children,
  data
}) => {

  const { user } = useSelector((state) => state.auth);
  const isTeacher = user?.roles?.includes(UserRoles?.TEACHER);
  const isOrganism = user?.roles?.includes(UserRoles?.ORGANISME);
  const isStudent = user?.roles?.includes(UserRoles?.STUDENT);

  return (
    <div className="navigation-tabs-container">
      {isOrganism ? <Tabs
        tabBarStyle={{ borderRadius: "0px", overflow: "hidden", border: "0px solid transparent !important", backgroundColor: "transparent !important", fontSize: "1em !important" }}
        activeKey={activeTab}
        onChange={(key) => onChange(key as TabType)}
        size="large"
        type="line"
      >
        <TabPane
          tab={
            <span className={activeTab == "students" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={Students} height={40} />
              Les élèves
            </span>
          }
          key="students"
        />
        <TabPane
          tab={
            <span className={activeTab == "groupClasses" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={CoursCollectifs} height={30} />
              Cours collectifs
            </span>
          }
          key="groupClasses"
        />
        <TabPane
          tab={
            <span className={activeTab == "publications" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={Publications} height={30} />
              Publications
            </span>
          }
          key="publications"
        />
        <TabPane
          tab={
            <span className={activeTab == "challenges" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={ClassIcon} height={30} style={{ position: "absolute", top: "25px", left: "30px" }} />
              <img src={GreenIdea} height={20} style={{ position: "absolute", top: "20px", left: "50px" }} />
              <span style={{ marginLeft: 40 }}>Challenges</span>
            </span>
          }
          key="challenges"
        />
      </Tabs> : isTeacher ? <Tabs
        tabBarStyle={{ borderRadius: "0px", overflow: "hidden", border: "0px solid transparent !important", backgroundColor: "transparent !important", fontSize: "1em !important" }}
        activeKey={activeTab}
        onChange={(key) => onChange(key as TabType)}
        size="large"
        type="line"
      >
        <TabPane
          tab={
            <span className={activeTab == "reservations" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={CoursCollectifs} height={30} />
              Cours réservés
            </span>
          }
          key="reservations"
        />
        <TabPane
          tab={
            <span className={activeTab == "availability" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={Calendar} height={25} />
              Mes cours proposés
            </span>
          }
          key="availability"
        />
        <TabPane
          tab={
            <span className={activeTab == "publications" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={Publications} height={30} />
              Publications
            </span>
          }
          key="publications"
        />
        <TabPane
          tab={
            <span className={activeTab == "challenges" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={ClassIcon} height={30} style={{ position: "absolute", top: "25px", left: "30px" }} />
              <img src={GreenIdea} height={20} style={{ position: "absolute", top: "20px", left: "50px" }} />
              <span style={{ marginLeft: 40 }}>Challenges</span>
            </span>
          }
          key="challenges"
        />
      </Tabs> : isStudent && <Tabs
        tabBarStyle={{ borderRadius: "0px", overflow: "hidden", border: "0px solid transparent !important", backgroundColor: "transparent !important", fontSize: "1em !important" }}
        activeKey={activeTab}
        onChange={(key) => onChange(key as TabType)}
        size="large"
        type="line"
      >
        <TabPane
          tab={
            <span className={activeTab == "reservations" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={CoursCollectifs} height={30} />
              Cours réservés
            </span>
          }
          key="reservations"
        />
        {!data?.isCollective && <TabPane
          tab={
            <span className={activeTab == "propositions" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={Calendar} height={25} />
              {"Cours proposés"}
            </span>
          }
          key="propositions"
        />}
        <TabPane
          tab={
            <span className={activeTab == "publications" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={Publications} height={30} />
              Publications
            </span>
          }
          key="publications"
        />
        <TabPane
          tab={
            <span className={activeTab == "challenges" ? "tabTitleBoxActive" : "tabTitleBox"}>
              <img src={ClassIcon} height={30} style={{ position: "absolute", top: "25px", left: "30px" }} />
              <img src={GreenIdea} height={20} style={{ position: "absolute", top: "20px", left: "50px" }} />
              <span style={{ marginLeft: 40 }}>Challenges</span>
            </span>
          }
          key="challenges"
        />
      </Tabs>}
      <div className="tab-content">{children}</div>
    </div>
  );
};

export default NavigationTabs;
